export default "__VITE_ASSET___Ouk$B4F__"